(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      const closeButton = this.querySelector('.announcement__close');
      const ad = window.sessionStorage.getItem('announcementDismissed');

      if (!ad) {
        this.classList.remove('hide');
      }

      if (closeButton) {
        closeButton.addEventListener('click', this.hideAnnouncement.bind(this));
      }
    }

    hideAnnouncement() {
      window.sessionStorage.setItem('announcementDismissed', true);
      this.classList.add('announcement-bar--hide');

      setTimeout(() => {
        this.style.display = 'none';
      }, 300);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-signup-banner"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    class SignupBanner extends HTMLElement {
      constructor() {
        super();

        this.signupForm = this.querySelector('.newsletter-form');

        if (this.signupForm) {
          this.submitButton = this.signupForm.querySelector('button[type="submit"]');

          if (this.submitButton) {
            this.submitButton.removeAttribute('disabled');
          }

          clearInputErrors(this.signupForm);

          this.signupForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      handleSubmit(evt) {
        const formIsValid = validateForm(this.signupForm);

        if (formIsValid) {
          if (this.submitButton) {
            this.submitButton.classList.add('btn--loading');
          }
        } else {
          evt.preventDefault();
        }
      }
    }

    customElements.define('signup-banner', SignupBanner);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-linked-menu"]) return;
  try {
    
  class FaqLinkedMenu extends HTMLElement {
    constructor() {
      super();
      this.faqLinkedMenuContent = this.querySelector('.faq-linked-menu-content');
      this.accordionComponent = document.querySelectorAll('.faq-item');
      const faqlinkedItems = [];

      this.accordionComponent.forEach((elm, i) => {
        if (i != 0) {
          elm.classList.add('hide');
        }

        const faqLinkedMenuSection = elm.querySelector('[data-menu-info="faq-linked-menu"]');

        if (faqLinkedMenuSection) {
          const newMenuItem = document.createElement('li');
          newMenuItem.dataset.linkType = elm.dataset.sectionType;
          newMenuItem.innerHTML = faqLinkedMenuSection.innerHTML;

          if (i === 0) {
            newMenuItem.classList.add('active');
          }

          this.faqLinkedMenuContent.appendChild(newMenuItem);

          newMenuItem.addEventListener('click', this.handleClick.bind(this));
        }

        faqLinkedMenuSection.classList.add('hide');
      });
    }

    handleClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const contentId = target.dataset.linkType;

      const activeElement = document.querySelector(`[data-section-type=${contentId}]`);
      const activeHeaderItem = this.faqLinkedMenuContent.querySelector('li.active');

      if (activeHeaderItem !== target) {
        activeHeaderItem.classList.remove('active');
        target.classList.add('active');
      }

      this.accordionComponent.forEach((elm) => {
        if (!elm.classList.contains('hide')) {
          elm.classList.add('collapsible-content--hide');
          setTimeout(function () {
            elm.classList.add('hide');
          }, 200);
        }
      });

      setTimeout(function () {
        activeElement.classList.remove('hide');
        activeElement.classList.remove('collapsible-content--hide');
      }, 200);
    }
  }

  customElements.define('faq-linked-menu', FaqLinkedMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-brand-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-gb-story-top]');
    if (!a) return;
    const target = document.querySelector('.gb-grid');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-collection-explore"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.gbReady) return;
      root.dataset.gbReady = '1';
      const shelf = () => root.querySelector('.gb-explore__shelf:not([hidden])');
      const prev = root.querySelector('[data-gb-prev]');
      const next = root.querySelector('[data-gb-next]');
      const arrows = () => {
        const s = shelf();
        if (!s || !prev || !next) return;
        prev.disabled = s.scrollLeft < 6;
        next.disabled = s.scrollLeft + s.clientWidth > s.scrollWidth - 6;
      };
      const centre = () => {
        const s = shelf();
        const cur = s && s.querySelector('.is-current');
        if (cur) { s.style.scrollBehavior = 'auto'; s.scrollLeft = Math.max(0, cur.offsetLeft - (s.clientWidth - cur.clientWidth) / 2); s.style.scrollBehavior = ''; }
        arrows();
      };
      root.querySelectorAll('.gb-explore__tab').forEach((tab) => {
        tab.addEventListener('click', () => {
          root.querySelectorAll('.gb-explore__tab').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
          root.querySelectorAll('.gb-explore__shelf').forEach((p) => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
          const s = shelf(); if (s) s.scrollLeft = 0;
          arrows();
        });
      });
      root.querySelectorAll('.gb-explore__shelf').forEach((s) => s.addEventListener('scroll', arrows, { passive: true }));
      if (prev) prev.addEventListener('click', () => { const s = shelf(); if (s) s.scrollBy({ left: -s.clientWidth * 0.75 }); });
      if (next) next.addEventListener('click', () => { const s = shelf(); if (s) s.scrollBy({ left: s.clientWidth * 0.75 }); });
      window.addEventListener('resize', arrows);
      centre();

      // Auto scroll: one tile at a time, back to the start at the end. Pauses while a shopper hovers,
      // touches or tabs into the carousel, while it is off screen, and for reduced-motion users.
      const secs = parseFloat(root.dataset.gbAutoplay);
      const glide = parseFloat(root.dataset.gbGlide);
      // Continuous: the tiles glide slowly and loop without a jump (the tiles are repeated once, hidden from
      // screen readers). Pauses the same way as the step mode below.
      if (glide > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.querySelectorAll('.gb-explore__shelf').forEach((s) => {
          const tiles = [...s.querySelectorAll('.gb-explore__tile')];
          tiles.forEach((t) => { const c = t.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('tabindex', '-1'); c.classList.add('is-clone'); c.querySelectorAll('img').forEach((i) => i.setAttribute('loading', 'eager')); s.appendChild(c); });
          s.style.scrollSnapType = 'none';
          s.style.scrollBehavior = 'auto';
        });
        let held = false, visible = true, rest = 0, pos = 0, last = 0, cur = null;
        const loopW = (s) => { const c = s.querySelector('.is-clone'); const f = s.querySelector('.gb-explore__tile'); return c && f ? c.offsetLeft - f.offsetLeft : 0; };
        const frame = (t) => {
          const s = shelf();
          const dt = last ? Math.min(64, t - last) : 0; last = t;
          if (s) {
            if (s !== cur) { cur = s; pos = s.scrollLeft; }
            if (held || !visible || document.hidden || Date.now() < rest) pos = s.scrollLeft;
            else {
              pos += glide * dt / 1000;
              const w = loopW(s);
              if (w > 0 && pos >= w) pos -= w;
              s.scrollLeft = pos;
            }
          }
          requestAnimationFrame(frame);
        };
        const carousel = root.querySelector('.gb-explore__carousel') || root;
        const hold = () => { held = true; };
        const release = () => { held = false; rest = Date.now() + 1200; };
        carousel.addEventListener('mouseenter', hold);
        carousel.addEventListener('mouseleave', release);
        carousel.addEventListener('focusin', hold);
        carousel.addEventListener('focusout', release);
        carousel.addEventListener('touchstart', hold, { passive: true });
        carousel.addEventListener('touchend', release, { passive: true });
        [prev, next].forEach((b) => b && b.addEventListener('click', () => { rest = Date.now() + 2500; }));
        root.querySelectorAll('.gb-explore__tab').forEach((t) => t.addEventListener('click', () => { pos = 0; rest = Date.now() + 1500; }));
        if ('IntersectionObserver' in window) new IntersectionObserver((e) => { visible = e[0].isIntersecting; }).observe(root);
        requestAnimationFrame(frame);
      } else if (secs > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let held = false;
        let visible = true;
        let rest = 0;
        const step = () => {
          const s = shelf();
          if (!s || held || !visible || Date.now() < rest || document.hidden) return;
          const tile = s.querySelector('.gb-explore__tile');
          if (!tile) return;
          if (s.scrollLeft + s.clientWidth >= s.scrollWidth - 6) s.scrollTo({ left: 0 });
          else s.scrollBy({ left: tile.offsetWidth + parseFloat(getComputedStyle(s).columnGap || 0) });
        };
        const carousel = root.querySelector('.gb-explore__carousel') || root;
        const hold = () => { held = true; };
        const release = () => { held = false; rest = Date.now() + secs * 1000; };
        carousel.addEventListener('mouseenter', hold);
        carousel.addEventListener('mouseleave', release);
        carousel.addEventListener('focusin', hold);
        carousel.addEventListener('focusout', release);
        carousel.addEventListener('touchstart', hold, { passive: true });
        carousel.addEventListener('touchend', release, { passive: true });
        [prev, next].forEach((b) => b && b.addEventListener('click', () => { rest = Date.now() + secs * 2000; }));
        root.querySelectorAll('.gb-explore__tab').forEach((t) => t.addEventListener('click', () => { rest = Date.now() + secs * 1000; }));
        if ('IntersectionObserver' in window) new IntersectionObserver((e) => { visible = e[0].isIntersecting; }).observe(root);
        setInterval(step, secs * 1000);
      }
    };
    const all = () => document.querySelectorAll('.gb-explore').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.gbReady) return;
      root.dataset.gbReady = '1';
      const bar = root.querySelector('.gb-bar--sticky');
      const extra = parseInt(getComputedStyle(root).getPropertyValue('--gb-sticky-top'), 10) || 0;
      const header = document.querySelector('sticky-header') || document.querySelector('.shopify-section-group-header-group');
      const placeBar = () => {
        if (!bar) return;
        let top = 0;
        if (header) {
          const pos = getComputedStyle(header).position;
          const rect = header.getBoundingClientRect();
          if (pos === 'sticky' || pos === 'fixed' || rect.top >= 0) top = Math.max(0, rect.bottom);
        }
        bar.style.top = `${top + extra}px`;
      };
      placeBar();
      window.addEventListener('scroll', placeBar, { passive: true });
      window.addEventListener('resize', placeBar);
      const panel = root.querySelector('[data-gb-panel]');
      const toggle = root.querySelector('[data-gb-filter-toggle]');
      const scrim = root.querySelector('[data-gb-scrim]');
      const form = root.querySelector('[data-gb-form]');
      const phone = () => window.matchMedia('(max-width: 860px)').matches;
      const setOpen = (on) => {
        if (!panel) return;
        panel.classList.toggle('is-open', on);
        if (toggle) toggle.setAttribute('aria-expanded', String(on));
        if (scrim) scrim.classList.toggle('is-on', on && phone());
        document.body.style.overflow = on && phone() ? 'hidden' : '';
      };
      if (toggle) toggle.addEventListener('click', () => setOpen(!panel.classList.contains('is-open')));
      root.querySelectorAll('[data-gb-filter-close]').forEach((b) => b.addEventListener('click', () => setOpen(false)));
      if (scrim) scrim.addEventListener('click', () => setOpen(false));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
      root.querySelectorAll('[data-gb-more]').forEach((b) => b.addEventListener('click', () => {
        b.closest('.gb-panel__options').querySelectorAll('[data-gb-extra]').forEach((x) => { x.hidden = false; });
        b.remove();
      }));
      const go = () => {
        const params = new URLSearchParams(new FormData(form));
        for (const [k, v] of [...params.entries()]) if (v === '') params.delete(k);
        window.location.href = `${form.action}?${params.toString()}#${root.id}`;
      };
      if (form) {
        form.addEventListener('submit', (e) => { e.preventDefault(); go(); });
        form.addEventListener('change', (e) => { if (!phone() && e.target.type === 'checkbox') go(); });
      }
      const sort = root.querySelector('[data-gb-sort]');
      if (sort) sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        url.hash = root.id;
        window.location.href = url.toString();
      });
      const search = root.querySelector('[data-gb-search]');
      const list = root.querySelector('#data-pagination');
      const nomatch = root.querySelector('[data-gb-nomatch]');
      let loadedAll = false;
      const loadAll = async () => {
        if (loadedAll || !list) return;
        loadedAll = true;
        const pages = parseInt(list.dataset.pages || '1', 10);
        const current = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
        const seen = new Set([...list.querySelectorAll('.data-pagination__item')].map((li) => li.textContent.trim()));
        for (let p = 1; p <= pages; p++) {
          if (p === current) continue;
          const url = new URL(window.location.href);
          url.searchParams.set('page', p);
          url.searchParams.set('section_id', root.dataset.sectionId);
          url.hash = '';
          const html = await fetch(url.toString()).then((r) => r.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('#data-pagination .data-pagination__item').forEach((li) => {
            const key = li.textContent.trim();
            if (!seen.has(key)) { seen.add(key); list.appendChild(li); }
          });
        }
        const more = root.querySelector('#component-pagination-loader');
        if (more) more.hidden = true;
      };
      if (search && list) {
        let t;
        search.addEventListener('input', () => {
          clearTimeout(t);
          t = setTimeout(async () => {
            const q = search.value.trim().toLowerCase();
            if (q) await loadAll();
            let shown = 0;
            list.querySelectorAll('.data-pagination__item').forEach((li) => {
              if (li.classList.contains('gb-banner')) { li.hidden = !!q; return; } // offer banners only show on the unfiltered list
              const hit = !q || li.textContent.toLowerCase().includes(q);
              li.hidden = !hit;
              if (hit) shown++;
            });
            if (nomatch) nomatch.hidden = shown > 0;
          }, 200);
        });
      }
    };
    const all = () => document.querySelectorAll('.gb-grid').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.background = this.getAttribute('data-background');
      this.applyColorScheme = this.getAttribute('data-color-scheme');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.headerSearch = this.querySelector('.header__search');

      this.headerHeight = this.header.getBoundingClientRect().height;
      this.headerWrap = this.header.querySelector('.header-wrapper');
      this.isFrosted = this.headerWrap.dataset.frosted;
      this.isSticky = this.headerWrap.dataset.sticky;
      this.menuInline = this.header.querySelector('.list-menu--inline');
      this.activeMenuItem = this.header.querySelector('.header__active-menu-item');
      this.listMenuItems = this.header.querySelectorAll('.header__inline-menu .list-menu__item-list');

      this.openingMenu = false;
      this.closingMenu = false;
      this.isFadeOutTransition = false;
      this.listMenuItems.forEach((listMenuItem) => listMenuItem.addEventListener('mouseenter', this.handleMouseEnter.bind(this)));
      this.listMenuItems.forEach((listMenuItem) => listMenuItem.addEventListener('mouseleave', this.handleMouseleave.bind(this)));
      this.listMenuItems.forEach((listMenuItem) => listMenuItem.addEventListener('click', this.handleClick.bind(this)));

      if (this.isSticky) {
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      const searchHomeField = document.getElementById('search-home-field');
      let headerHeight = this.header.getBoundingClientRect().height;
      if (searchHomeField) {
        headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
        if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
          searchHomeField.classList.add('search-home--transparent');
        }
      }
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      let prevHeight = 0;
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.contentBoxSize) {
            const height = entry.contentBoxSize?.[0].blockSize;
            if (typeof height === 'number' && height !== prevHeight) {
              prevHeight = height;
              let headerHeight = this.header.getBoundingClientRect().height;
              if (searchHomeField) {
                headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
              }
              document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
            }
          }
        }
      });

      resizeObserver.observe(this.header);
      this.setupTransparency();
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:unload', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:reorder', this.setupTransparency.bind(this));
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.headerSearch && this.headerSearch.isOpen()) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (!this.applyColorScheme) {
        this.header.classList.add(this.background);
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      if (!this.applyColorScheme) {
        this.header.classList.add(this.background);
      }
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

      if (!this.applyColorScheme) {
        this.header.classList.remove(this.background);
      }
    }

    handleClick(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');

      this.header.classList.add(this.background, 'is-filled');

      if (detailsElement) {
        setTimeout(() => {
          detailsElement.classList.add('sub-menu-opening');
        });
      }
    }

    handleMouseEnter(event) {
      const menuItem = event.target;
      const menuItemSpan = menuItem.querySelector('.header__menu-item');
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });
      menuItemSpan.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.closingMenu && detailsElement.getAttribute('open') && !this.isFadeOutTransition) {
        window.clearTimeout(this.timeoutClose);
        this.closingMenu = false;
      }

      if (detailsElement.getAttribute('open') && !this.isFadeOutTransition) return;

      window.clearTimeout(this.timeoutOpen);
      this.openingMenu = true;

      this.timeoutOpen = setTimeout(() => {
        this.openingMenu = false;
        this.openSubMenu(detailsElement);
      }, 300);
    }

    openSubMenu(detailsElement) {
      detailsElement.setAttribute('open', true);
      if (this.isFrosted) this.headerWrap.classList.remove('frosted-header-glass');
      this.header.classList.add(this.background, 'is-filled');
      this.closeMenuLocalization();
      setTimeout(() => {
        detailsElement.classList.add('sub-menu-opening');
      });
    }

    handleMouseleave(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });

      if (this.activeMenuItem) this.activeMenuItem.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.openingMenu && !detailsElement.getAttribute('open')) {
        window.clearTimeout(this.timeoutOpen);
        this.openingMenu = false;
      }

      if (!detailsElement.getAttribute('open')) return;

      this.closingMenu = true;
      this.timeoutClose = setTimeout(() => {
        this.closingMenu = false;
        this.closeSubMenu(detailsElement);
      }, 300);
    }

    closeSubMenu(detailsElement) {
      if (this.isFrosted) this.headerWrap.classList.add('frosted-header-glass');
      this.header.classList.remove('is-filled');
      if (!this.header.classList.contains('animate')) {
        this.header.classList.remove(this.background);
      }

      detailsElement.classList.remove('sub-menu-opening');
      this.isFadeOutTransition = true;

      detailsElement.addEventListener(
        'transitionend',
        () => {
          detailsElement.removeAttribute('open');
          this.isFadeOutTransition = false;
        },
        { once: true }
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeMenuLocalization() {
      this.headerLocalization = this.headerLocalization || this.header.querySelectorAll('localization-form');
      this.headerLocalization.forEach((disclosure) => disclosure.hidePanel());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        // this.searchModal.close(false);
      }
    }

    setupTransparency() {
      if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
        this.classList.add(this.background);
        this.setAttribute('data-transparency', true);
      } else {
        if (this.isSticky && !this.applyColorScheme) {
          this.classList.remove(this.background);
        }
        this.removeAttribute('data-transparency');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  class newsletterForm extends HTMLElement {
    constructor() {
      super();
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      const sectionId = this.dataset.sectionId;
      const contactNewsletter = this.querySelector(`#Contact_${sectionId}`);
      const inputEmailGroup = contactNewsletter.querySelector('.input-group');
      const inputEmailNewsletter = contactNewsletter.querySelector('input[type="email"]');
      const errorMessage = contactNewsletter.querySelector(`#Newsletter-error--${sectionId}`);
      const errorMessageText = errorMessage.querySelector('.input-error-message__text');
      const iconError = contactNewsletter.querySelector('.field-wrapper__icon-error');
      const existingEmailMsg = contactNewsletter.querySelector('.newsletter-email-exist');
      const urlUserCame = document.referrer ? new URL(document.referrer) : null;

      inputEmailNewsletter.addEventListener('keyup', function (e) {
        if (e.code === 'Enter') return;
        inputEmailGroup.classList.remove('input-group--error');
        inputEmailNewsletter.classList.remove('input--error');
        errorMessage.classList.add('hide');
        iconError.classList.add('hide');
        if (existingEmailMsg) existingEmailMsg.classList.add('hide');
      });

      if (existingEmailMsg && searchParams.has('form_type') && inputEmailNewsletter.value) {
        existingEmailMsg.classList.remove('hide');
      }

      if ( urlUserCame && urlUserCame.pathname === '/challenge' ) {
        document.querySelector(`#Contact_${sectionId}`).scrollIntoView();
      }

      contactNewsletter.addEventListener('submit', (event) => {
        const email = inputEmailNewsletter.value;

        if (!this.validateEmail(email)) {
          event.preventDefault();
          var erroMessage = '';

          if (email === '') {
            erroMessage = window.loginStrings.errorEmailRequired;
          } else {
            erroMessage = window.loginStrings.errorEmailInvalid;
          }

          inputEmailGroup.classList.add('input-group--error');
          inputEmailNewsletter.classList.add('input--error');
          inputEmailNewsletter.setAttribute('aria_invalid', 'true');
          inputEmailNewsletter.setAttribute('aria_describedby', `Newsletter-error--${sectionId}`);
          inputEmailNewsletter.setAttribute('data_form_status', true);

          if (errorMessageText) errorMessageText.textContent = erroMessage;
          errorMessage.classList.remove('hide');
          iconError.classList.remove('hide');
          inputEmailNewsletter.focus();
        }

        return false;
      });
    }

    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }

  customElements.define('newsletter-form', newsletterForm);

  } catch(e) { console.error(e); }
})();
})();
